<div class="advanced-settings">
  <div class="content">
    <ng-container *ngIf="userInfo?.isVerified; else elseBlock">
      <div class="content__title">Reset Password</div>
      <div class="content__box">
        <label class="input">
          <input class="input__field" type="password" placeholder=" " [(ngModel)]="passcode" />
          <span class="input__label">New Passcode</span>
        </label>
        <label class="input">
          <input class="input__field" type="password" placeholder=" " [(ngModel)]="passcodeConfirm" />
          <span class="input__label">New Passcode Confirmation</span>
        </label>
        <label class="input">
          <button class="btn btn-dark btn-otp" (click)="handleSendOTP()">
            Send OTP<span *ngIf="delaySendOTP > 0" class="ml-2">({{ delaySendOTP }})</span>
          </button>
          <input class="input__field" placeholder=" " type="number" minlength="6" maxlength="6" [(ngModel)]="otp"
            (keyup)="$event.target.value = $event.target.value.substr(0, 6)" />
          <span class="input__label">Enter OTP</span>
        </label>
      </div>
      <button class="my-button-3 d-flex m-auto" (click)="handleVerify()"><i class="fa-solid fa-save"></i>
        Verify</button>
    </ng-container>
    <ng-template #elseBlock>
      <div class="content__title">Account Verification Required</div>
      <div class="content__box">
        <div class="content__description">
          Please verify your account before resetting your password.
          Visit your profile settings to complete the verification process.
        </div>
      </div>
      <button class="my-button-3 d-flex m-auto" routerLink="/advanced-settings/verify"><i class="fa-solid fa-save"></i>
        Verify</button>
    </ng-template>

  </div>
</div>